'use strict';

var linchpin = require('int_googletagmanager/linchpin/orderconfirmation'),
	linchpinCheckout = require('int_googletagmanager/linchpin/checkoutInfo'),
	login = require('int_googletagmanager/linchpin/login'),
	logger = require('site/logger'),
	subscriptions = require('int_googletagmanager/linchpin/subscription'),
	cart = require('site/pages/cart');

exports.init = function () {
	// print handler
	$('.print-page').on('click', function (e) {
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.orderPrintEvent(e);
		}
	});

	// GTM Linchpin analytics
	try {
		if (SitePreferences.GTM_ENABLED) {
			linchpin.orderReviewEvent();
			$('.login-box-content form button').on('click', function () {
				linchpin.registrationConfirmationAttemptEvent();
			});
		}
	} catch (e) {
		logger.log(e.message, 'error');
	}

	// GTM Linchpin analytics
	if ($('input[name=loginSucceeded]').length > 0 && SitePreferences.GTM_ENABLED) {
		var email;
		if ($('input[name*=_customer_email').length > 0) {
			email = $('input[name*=_customer_email').val();
		}
		var status = $('input[name=loginSucceeded]').val();
		login.loginEvent(status, email);
	}

	if (SitePreferences.GTM_ENABLED) {
		subscriptions.addSubscriptionAddToBagEvents();
		// track payment info for confirmation page as well
		linchpinCheckout.paymentInfoEvent();
	}

	if (window.User.isAppWebView && window.PoqWebCheckout) {
		var poqRequest = $('[name="poqOrderRequest"]').val();
		if (poqRequest) {
			var poqRequestObj = JSON.parse(poqRequest);
			window.PoqWebCheckout.send('paymentcompleted', poqRequestObj);
		}
		$('.pt_order-confirmation #continue-shopping').on('click', function () {
			window.PoqWebCheckout.send('closewebview');
		});
	}

	$('.order-confirmation-details').on('click', '.confirmation-toggle-title', function (e) {
		$(this).toggleClass('on');
		if ($(this).hasClass('on')) {
			$(this).next('.toggleContent').addClass('show-content');
			$(this).next('.toggleContent').removeClass('hide-content');
		} else {
			$(this).next('.toggleContent').removeClass('show-content');
			$(this).next('.toggleContent').addClass('hide-content');
		}
		e.preventDefault();
	});

	// toggling components of Build a box bundle
	cart.toggleBaBComponents();

	if (window.algoliaData && window.algoliaData.enable) {
		var event = new CustomEvent('algoliainsights:purchase');
		document.dispatchEvent(event);
	}
};
